export default __webpack_public_path__ + "static/media/about.044861f7.jpg";